import { observable } from 'mobx'
import NGLTowerConstraintsAPI from '../service/tower-constraints-service'
import { AppConstants } from '../../../common/APIConstants'
import { columnDefinition } from '../service/towerColumnDef'
import { makesRowToBeUpated, getCustomizedRowData, getDaysMonthYear } from '../utils'


class NGLTowerConstraintsStore {
    @observable screenRowData = []
    @observable screenRowDataBackup = []
    @observable screenColumnDefinitions = []
    @observable selectedDate = new Date()
    @observable rowsUpdated = []
    @observable commentsBackup = null
    @observable comments = null

    // Retrieve data and set in store variables
    async getScreenData(payload, CommonStore) {
        CommonStore.toggleLoader()
        try {
            //comments
            const commentsPayload = {
                Month: payload.Month,
                Year: payload.Year
            }
            // fetch tower data for grid
            const { data } = await NGLTowerConstraintsAPI.getScreenData(payload);
            // fetch comments
            const commentsRes = await NGLTowerConstraintsAPI.getComments(commentsPayload)
            this.screenColumnDefinitions = columnDefinition()
            const customizedRowData = getCustomizedRowData(data, payload.Dates)
            this.screenRowData = customizedRowData
            this.screenRowDataBackup = data
            this.comments = commentsRes?.data[0]?.Comments
            this.commentsBackup = commentsRes?.data[0]?.Comments
            CommonStore.toggleLoader()
        } catch (err) {
            console.log(err)
            CommonStore.toggleLoader()
        }
    }

    // Save updated rows
    async saveScreenData(CommonStore) {
        CommonStore.toggleLoader();
        const dataToBeUpdated = makesRowToBeUpated(this.rowsUpdated)
        try {
            const payload = {
                Data: dataToBeUpdated
            }

            // update grid data
            await NGLTowerConstraintsAPI.saveScreenData(payload)
            // Check whether comments changed or not, then update it
            if (JSON.stringify(this.comments) !== JSON.stringify(this.commentsBackup)) {
                const { selectedMonth, selectedYear } = getDaysMonthYear(this.selectedDate)
                const payload = {
                    Data: [{
                        Month: selectedMonth,
                        Year: selectedYear,
                        Comments: this.comments
                    }]
                }
                await NGLTowerConstraintsAPI.saveComments(payload)
            }
            this.clearRequiredMemory()
            CommonStore.toggleLoader();
            window.toastr.success(AppConstants.TOASTER_SUCCESS);
        } catch (err) {
            this.clearRequiredMemory()
            CommonStore.toggleLoader();
            window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
        }
    }

    clearRequiredMemory = () => {
        this.rowsUpdated = []
        this.screenRowDataBackup = []
        this.screenRowData = []
        this.comments = null
        this.commentsBackup = null
    }
}

export default new NGLTowerConstraintsStore()